export default __webpack_public_path__ + "static/media/help24b.91b2e2d5.png";